"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shipperProfileMock = exports.shipperUserMock = void 0;
exports.shipperUserMock = {
    email: 'shipper-portal@sennder.com',
    firstName: 'Shipper',
    lastName: 'Portal',
    language: 'en',
    timezone: null,
    username: null,
    shipperUuid: '086ad789-41e9-43c9-ab21-19097e3dc8eb',
    id: '25ad0b47-c95b-415a-955a-33ff34240ed3',
    active: true,
    auth0Id: 'auth0|66507142d5d56bf320b84931'
};
exports.shipperProfileMock = {
    email: 'user@example.com',
    name: 'John Doe',
    picture: 'https://example.com/picture.jpg',
    id: '1234-5678-91011',
    language: 'en'
};
